// Auto-generated from server/src/Jobs.Domain/Constants/AttachmentSectionDataConstants.cs
// Do not modify manually - run 'npm run generate-constants' to regenerate

export const AttachmentSectionDataConstants = {
  PreProduction: '83324974-12d5-4d5b-9e9c-c6daaa6e4f78',
  Production: 'e411e5c5-0b89-4377-abf4-f7dcdafcb270',
  ProactiveService: '8e496db1-dbaf-44f5-9348-0828aeb53c29',
  ReactiveService: 'af2b48a5-4fa0-4f1f-9626-c8a0ff619f51',
  Accounting: '60bb0dbe-344e-459d-b3c9-a54ac24d7c85',
  JobCosting: 'aae58c33-463e-4f8b-89a1-31ff67393179',
  PrepaidService: '7e26e1ed-6e60-47cb-ae61-fb35ceedaa56'
} as const;
